export default __webpack_public_path__ + "static/media/Category.936cdf80.svg";